import ContactUs from "../components/contact-us/contact-us.component";
import HomePage from "../components/home-page/home-page.component";
import ProductsContainer from "../components/products-container/products-container.component";
import GettingStarted from "../components/getting-started/getting-started.component";
import { ROUTES } from "../constants/routes.constants";
import { isLoggedInUser } from "../utils/app.utils";

const  { HOME,  PRODUCT_MAIN, CONTACT_US, SUPPORT_FAQS,GETTING_STARTED} = ROUTES;

const loggedInUser =  isLoggedInUser();

export const HeaderConfig  = [
    {
        displayName: "Home",
        enabled: true,
        component: HomePage,
        route: HOME
    },{
        displayName: "Products",
        enabled: true,
        component: ProductsContainer,
        route: PRODUCT_MAIN
    },{
        displayName: "Support & FAQs",
        enabled: true,
        route: SUPPORT_FAQS
        
    },{
        displayName: "Contact Us",
        enabled: true,
        component: ContactUs,
        route: CONTACT_US
    },{
        displayName: "Getting Started",
        enabled: true,
        component: GettingStarted,
        route: GETTING_STARTED
    }
]